// Old "new base product" URLs. With the unified editor on, they redirect to
// step 1 in the editor shell (keeping any handoff state); otherwise the old
// page renders unchanged.

import React, { Suspense } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useFeatureFlag } from "../../../helpers/featureFlags";
import { UNIFIED_BLANK_EDITOR_FLAG } from "../unifiedEditor";

// Creating a base product from inside product creation ("add it now, then
// open the customizer") still finishes in the old flow, which hands back
// to the customizer. Only the plain create path moves to the new setup.
const inCustomizerHandoff = (state) =>
  Boolean(state?.continueToCustomizer || state?.productCreationReturn);

export function newSetupPathFor(pathname = "") {
  const m = String(pathname).match(/^\/blank-products\/new(?:\/(supplier-product|catalog-product))?\/?$/);
  if (!m) return null;
  return m[1] ? `/products/blanks/new/${m[1]}` : "/products/blanks/new";
}

export function withLegacyCreateRedirect(Legacy) {
  return function LegacyCreateRedirect(props) {
    const unified = useFeatureFlag(UNIFIED_BLANK_EDITOR_FLAG);
    const location = useLocation();
    const target =
      unified && !inCustomizerHandoff(location.state)
        ? newSetupPathFor(location.pathname)
        : null;
    if (target) {
      return <Navigate to={`${target}${location.search || ""}`} replace state={location.state} />;
    }
    return (
      <Suspense fallback={null}>
        <Legacy {...props} />
      </Suspense>
    );
  };
}
